class ItemData {
    constructor(data) {
        // Map incoming JSON to the class properties
        this.itemType = data.itemType ?? null;
        this.market = {
            count: data.market?.quantity ?? null,
            bestSo: data.market?.bestSo ?? null,
            bestBo: data.market?.bestBo ?? null
        };
        this.user = {
            count: data.user?.quantity ?? null,
            sellOffer: {
                price: data.user?.sellOffer?.price ?? null,
                quantity: data.user?.sellOffer?.quantity ?? null,
                since: data.user?.sellOffer?.since ?? null
            },
            buyOffer: {
                price: data.user?.buyOffer?.price ?? null,
                quantity: data.user?.buyOffer?.quantity ?? null,
                since: data.user?.buyOffer?.since ?? null
            }
        };
    }

    getMarketQuantity() {
        return this.market.count;
    }

    isUserSellOffer() {
        return this.user?.sellOffer?.quantity > 0;
    }

    hasUserItem() {
        return this.user?.count > 0;
    }

    getUserQuantity() {
        return this.user?.count ?? 0;
    }

    isUserSelling() {
        return this.user?.sellOffer?.quantity > 0;
    }

    isUserBuying() {
        return this.user?.buyOffer?.quantity > 0;
    }

    getUserSo() {
        return this.user?.sellOffer?.price;
    }

    getUserSellingQuantity() {
        return this.user?.sellOffer?.quantity;
    }

    getMarketSo() {
        return this.market.bestSo;
    }

    getUserBo() {
        return this.user?.buyOffer?.price;
    }

    getUserBuyingQuantity() {
        return this.user?.buyOffer?.quantity;
    }

    getMarketBo() {
        return this.market.bestBo;
    }

    isMarketSo() {
        return !!this.market.bestSo;
    }

    isMarketBo() {
        return !!this.market.bestBo;
    }

    getUserSellingSince() {
        return this.user?.sellOffer?.since;
    }

    getUserBuyingSince() {
        return this.user?.buyOffer?.since;
    }
}

export default ItemData;